<template>
  <div class="projects">
    <router-link
      :to="{ name: 'project', params: { id: project.key } }"
      tag="div"
      class="project"
      v-for="project in projects"
      :style="{ 'border-top-color': project.colour }"
      :key="project.key">
      {{ project.name }}
    </router-link>
    <NewProject v-if="isActive" />
  </div>
</template>

<script>
import NewProject from '@/components/project/NewProject.vue'

export default {
  name: 'ProjectList',
  components: { NewProject },
  props: ['projects', 'isActive']
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';

.projects {
  @include flex(row, center, flex-start);
  flex-wrap: wrap;
  margin-bottom: 48px;

  .project:first-child {
    margin-top: 8px;
  }

  @media (min-width: 450px) {
    @include flex(row, flex-start, flex-start);
  }
}

.project {
  @include flex(column, center, center);
  width: 100%;
  height: 136px;
  border-top: solid 8px #0000ff;
  border-radius: 4px;
  background-color: $gd-white;
  @include default-shadow(1px);
  margin-bottom: 24px;
  cursor: pointer;

  @media (min-width: 450px) {
    width: 200px;
    margin: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/project/ProjectList.vue